/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  compactAppliedFilters,
  type CustomFieldFilterMap,
  type LeadCountPreset,
} from "./userManagementFilterUtils";

const filterFieldDefaults = {
  branchId: "",
  hierarchy: "",
  presetRole: "",
  routeKey: "",
  userCountPreset: "all" as LeadCountPreset,
  minUserCount: "",
  maxUserCount: "",
  leadCountPreset: "all" as LeadCountPreset,
  minLeadCount: "",
  maxLeadCount: "",
};

export type RoleListFilterFieldDefaults = typeof filterFieldDefaults;

const initialState = {
  search: "",
  ...filterFieldDefaults,
  cfFilters: {} as CustomFieldFilterMap,
  appliedFilters: {} as Record<string, any>,
};

export type RoleListFilterState = typeof initialState;

const roleListFilterSlice = createSlice({
  name: "roleListFilter",
  initialState,
  reducers: {
    setRoleListSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      if (action.payload) state.appliedFilters.search = action.payload;
      else delete state.appliedFilters.search;
    },
    setRoleListFilterField(
      state,
      action: PayloadAction<{ key: keyof RoleListFilterFieldDefaults; value: any }>
    ) {
      (state as any)[action.payload.key] = action.payload.value;
    },
    setRoleListCustomField(
      state,
      action: PayloadAction<{ customInputId: string | number; value: string }>
    ) {
      const key = String(action.payload.customInputId);
      if (!action.payload.value || action.payload.value === "all") {
        delete state.cfFilters[key];
      } else {
        state.cfFilters[key] = action.payload.value;
      }
    },
    applyRoleListFilters(state) {
      state.appliedFilters = {
        ...(state.search ? { search: state.search } : {}),
        ...compactAppliedFilters(state as any, filterFieldDefaults, state.cfFilters),
      };
    },
    clearRoleListFilters() {
      return initialState;
    },
  },
});

export const {
  setRoleListSearch,
  setRoleListFilterField,
  setRoleListCustomField,
  applyRoleListFilters,
  clearRoleListFilters,
} = roleListFilterSlice.actions;

export default roleListFilterSlice.reducer;
